<template>
  <div class="con-cre-dev" :class="'dem--' + cpntTipo" v-if="[ '', null, undefined ].indexOf(contatoCre) === -1">
    <div v-show="cpntTipo === 'dev_fornecedor'" v-if="[ '', null, undefined ].indexOf(contatoCre.virtual_credito_fornecedor_historico) === -1">
      <table class="dem-dev-credito-tab" cellspacing="0">
        <tbody>
          <tr class="odd">
            <th>Total de créditos:<br></th>
            <td align="right" id="no-style-td-odd">
              R$ {{ contatoCre.virtual_credito_fornecedor_historico._CreditoTotal }}
            </td>
          </tr>
          <tr class="even">
            <th>Total utilizado:<br></th>
            <td align="right" id="no-style-td-even">
              R$ {{ contatoCre.virtual_credito_fornecedor_historico._CreditoUtilizado }}
            </td>
          </tr>
          <tr class="total">
            <th>Saldo disponível:</th>
            <td align="right">
              <b>R$ {{ contatoCre.virtual_credito_fornecedor_historico._CreditoDisponivel }}</b>
            </td>
          </tr>
        </tbody>
      </table>

      <button class="btn btn-default" @click="conCreDevOnClickRecibo('fornecedor')">
        <svg class="fa fa-print" aria-hidden="true"></svg>
        <div>
          Recibo de Crédito<br/>
          Dev. Fornecedor
        </div>
      </button>
      <div style="clear: both;">&nbsp;</div>
    </div>

    <div v-show="cpntTipo === 'dev_cliente'" v-if="[ '', null, undefined ].indexOf(contatoCre.virtual_credito_cliente_historico) === -1">
      <table class="dem-dev-credito-tab" cellspacing="0">
        <tbody>
          <tr class="odd">
            <th>Total de créditos:<br></th>
            <td align="right" id="no-style-td-odd">
              R$ {{ contatoCre.virtual_credito_cliente_historico._CreditoTotal }}
            </td>
          </tr>
          <tr class="even">
            <th>Total utilizado:<br></th>
            <td align="right" id="no-style-td-even">
              R$ {{ contatoCre.virtual_credito_cliente_historico._CreditoUtilizado }}
            </td>
          </tr>
          <tr class="total">
            <th>Saldo disponível:</th>
            <td align="right">
              <b>R$ {{ contatoCre.virtual_credito_cliente_historico._CreditoDisponivel }}</b>
            </td>
          </tr>
        </tbody>
      </table>

      <button class="btn btn-default" @click="conCreDevOnClickRecibo('cliente')">
        <svg class="fa fa-print" aria-hidden="true"></svg>
        <div>
          Recibo de Crédito<br/>
          Dev. Cliente
        </div>
      </button>
      <div style="clear: both;">&nbsp;</div>
    </div>

    <div style="width: 500px;" class="extrato">
      <table>
        <!-- <thead>
          <tr>
            <td class="origem">
              Data
            </td>
            <td class="debito">
              Origem
            </td>
            <td class="saldo">
              Valor
            </td>
          </tr>
        </thead> -->
        <tbody>
          <!-- <tr>
            <td class="origem">
              Saldo Inicial
            </td>
            <td class="debito">
              ---
            </td>
            <td class="credito">
              ---
            </td>
            <td class="saldo">
              R$ 0,00
            </td>
          </tr> -->
          <tr v-for="item in contatoCre.extrato" :key="item.demanda + '-' + item.dem_codigo">
            <td class="origem">
              <span v-html="item.vcto_pgto"></span>
            </td>
            <td class="debito">
              <App-Button @onClick="() => { conCreDevAbrirDemanda(item.demanda, item.dem_codigo) }"
              :cpntStatus='""' 
              :cpntClass='"btn btn-primary btn-sm"'>
                <template v-if="[ 'dem_dev_cliente' ].indexOf(item.demanda) !== -1">DC</template>
                <template v-else-if="[ 'dem_dev_fornecedor' ].indexOf(item.demanda) !== -1">DF</template>
                <template v-else-if="[ 'venda' ].indexOf(item.demanda) !== -1">V</template>
                <template v-else-if="[ 'dem_compra' ].indexOf(item.demanda) !== -1">C</template>
                <span v-html="(item.dem_codigo.length <= 4 ? ('0000' + item.dem_codigo).slice(-4) : item.dem_codigo)"></span>
              </App-Button>
            </td>
            <td class="saldo">
              <span v-if="[ 'dem_dev_cliente', 'dem_dev_fornecedor' ].indexOf(item.demanda) !== -1" style="font-weight: bold; color: blue;">
                + {{ item.valor }}
              </span>
              <span v-if="[ 'venda', 'dem_compra' ].indexOf(item.demanda) !== -1" style="font-weight: bold; color: red;">
                - {{ item.valor }}
              </span>

              <span v-if="[ '', null, undefined ].indexOf(item.saldo) === -1" style="font-size: calc(100% - 3px);"><br/>(Saldo {{ item.saldo }})</span>
            </td>
            <!-- <td class="saldo">
              {{ item.saldo }}
            </td> -->
          </tr>
        </tbody>
      </table>
      <!-- <table>
        <thead>
          <tr>
            <td class="origem">
              Origem / Data
            </td>
            <td class="debito">
              Débito
            </td>
            <td class="credito">
              Crédito
            </td>
            <td class="saldo">
              Saldo
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="origem">
              Saldo Inicial
            </td>
            <td class="debito">
              ---
            </td>
            <td class="credito">
              ---
            </td>
            <td class="saldo">
              R$ 0,00
            </td>
          </tr>
          <tr v-for="item in contatoCre.extrato" :key="item.demanda + '-' + item.dem_codigo">
            <td class="origem">
              <span v-html="item.vcto_pgto"></span>
              <App-Button
              :cpntStatus='""' 
              :cpntClass='"btn btn-primary btn-sm"'>
                <template v-if="[ 'dem_dev_cliente' ].indexOf(item.demanda) !== -1">DC</template>
                <template v-else-if="[ 'dem_dev_fornecedor' ].indexOf(item.demanda) !== -1">DF</template>
                <template v-else-if="[ 'venda' ].indexOf(item.demanda) !== -1">V</template>
                <template v-else-if="[ 'compra' ].indexOf(item.demanda) !== -1">C</template>
                <span v-html="(item.dem_codigo.length <= 4 ? ('0000' + item.dem_codigo).slice(-4) : item.dem_codigo)"></span>
              </App-Button>
            </td>
            <td class="debito">
              <template v-if="[ 'dem_dev_cliente', 'dem_dev_fornecedor' ].indexOf(item.demanda) !== -1">
                {{ item.valor }}
              </template>
              <template v-else>
                ---
              </template>
            </td>
            <td class="credito">
              <template v-if="[ 'venda', 'compra' ].indexOf(item.demanda) !== -1">
                {{ item.valor }}
              </template>
              <template v-else>
                ---
              </template>
            </td>
            <td class="saldo">
              {{ item.saldo }}
            </td>
          </tr>
        </tbody>
      </table> -->
    </div>

    <!-- <div class="linhas-pontilhadas">
  <span>01/03/2023</span>
  <span>123456789</span>
  <span>R$ 50,00</span>
</div>
<div class="linhas-pontilhadas">
  <span>02/03/2023</span>
  <span>987654321</span>
  <span>R$ 1000,00</span>
</div>
<div class="linhas-pontilhadas">
  <span>03/03/2023</span>
  <span>567891234</span>
  <span>R$ 1,00</span>
</div>
<div class="linhas-pontilhadas">
  <span>04/03/2023</span>
  <span>432156789</span>
  <span>R$ 2,50</span>
</div> -->

  </div>
</template>

<style scoped>
  .con-cre-dev {
    width: 100%;
    margin-top: 30px;
    margin-bottom: 30px;
    text-align: center;
  }


  .con-cre-dev > div {
    /* min-width: calc(50% - 10px); */
    /* display: inline-block; */
    vertical-align: top;
    width: 500px;
    margin: 0px auto;
  }

  .con-cre-dev > div > table ~ button {
    float: right;
  }

  .con-cre-dev > div > table.dem-dev-credito-tab {
    width: 350px;
    float: left;
  }

  .con-cre-dev > div > table {
    width: 100%;
    max-width: 350px;
    /* margin: 0px auto; */
    border-collapse: separate;
    border: 1px solid #CCC;
    background-color: transparent;
    border-radius: 5px;
  }
    .con-cre-dev > div > table tr:first-child th {
      border-top-left-radius: 5px;
    }
    .con-cre-dev > div > table tr:first-child td {
      border-top-right-radius: 5px;
    }
    .con-cre-dev > div > table tr:last-child th {
      border-bottom-left-radius: 5px;
    }
    .con-cre-dev > div > table tr:last-child td {
      border-bottom-right-radius: 5px;
    }
    .con-cre-dev.dem--dev_cliente > div > table tr th {
      border-bottom: 1px solid #32a6b0;
      text-align: left;
      background: #1d939f;
      color: #FFF;
    }
    .con-cre-dev.dem--dev_fornecedor > div > table tr th {
      border-bottom: 1px solid #d1a202;
      text-align: left;
      background: #ffc500;
      color: #444;
    }
    .con-cre-dev > div > table tr td {
      background: #FFF;
      color: #333 !important;
      border-bottom: 1px solid #D8D8D8;
      background: #FFF;
      color: #333;
    }
    .con-cre-dev > div > table tr th, 
    .con-cre-dev > div > table tr td {
      padding: 10px;
      margin: 0;
    }
    .con-cre-dev > div > table tr td:first-child,
    .con-cre-dev > div > table tr th:first-child {
      border-left: none;
      width: 140px;
    }
    .con-cre-dev > div > table tr:last-child td,
    .con-cre-dev > div > table tr:last-child th {
      border-bottom: none;
    }
  
  .con-cre-dev > div > button {
    margin-top: 30px;
  }

  .extrato,
  .extrato > table {
    width: 500px !important;
    max-width: 500px !important;
  }

  /* .extrato > table > thead > tr > td {
    border-bottom: 1px solid #CCC !important;
  } */

  .extrato > table > thead > tr > td.origem,
  .extrato > table > tbody > tr > td.origem {
    width: 185px;
    border-bottom: 1px dotted black !important;
  }
    
    .extrato > table > thead > tr > td.origem > button,
    .extrato > table > tbody > tr > td.origem > button {
      margin-left: 5px;
    }
  .extrato > table > thead > tr > td.saldo,
  .extrato > table > tbody > tr > td.saldo,
  .extrato > table > thead > tr > td.debito,
  .extrato > table > tbody > tr > td.debito,
  .extrato > table > thead > tr > td.credito,
  .extrato > table > tbody > tr > td.credito {
    width: calc((100% - 185px) / 3);
    border-bottom: 1px dotted black !important;
  }
  .extrato > table > tbody > tr > td.saldo {
    text-align: right;
    padding-right: 10px;
  }
  .extrato > table {
    border-collapse: collapse !important;
    /* border: 1px dotted black; */
    border: none !important;
  }

  .extrato > table,
  .extrato > table > tbody,
  .extrato > table > thead,
  .extrato > table > tbody > tr,
  .extrato > table > thead > tr
  .extrato > table > tbody > tr > td,
  .extrato > table > thead > tr > td {
    border-radius: initial !important;
  }

  .extrato > table > tbody > tr > td {
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    /* border-bottom: none !important; */
    /* border-bottom: 1px dotted black; */
  }

/*   
.linhas-pontilhadas {
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-bottom: 10px;
  font-family: monospace;
  font-size: 16px;
}

.linhas-pontilhadas::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  border-bottom: 1px dotted black;
  z-index: -1;
}

.linhas-pontilhadas span:first-child {
  flex-grow: 1;
  text-align: left;
  padding-right: 10px;
}

.linhas-pontilhadas span:nth-child(2) {
  flex-grow: 1;
  text-align: center;
  padding-right: 10px;
}

.linhas-pontilhadas span:last-child {
  flex-grow: 1;
  text-align: right;
} */
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntIdCon: {
        required: true,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntTipo: {
        required: true,
        type: String
      }
    },
    data: function () {
      return {
        time: '',
        contatoCre: null
      }
    },
    mounted: function () {
      this.conCreDevIniciar()
    },
    methods: {
      conCreDevIniciar: function () {
        this.conCreDevAlterarTipo()
      },
      conCreDevSetarStatusGeral: function (status) {
        this.$emit('SETAR_STATUS_GERAL', status)
      },
      conCreDevBuscarValores: function (callback = null) {
        // INICIA A QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1 } }

        // SETA OS CAMPOS QUE DEVE BUSCAR
        queryGet.field = {
          id: null,
          nome: null,
          cnpj_cpf: null,
          pessoa: null
        }

        // SETA O FIELD VIRTUAL
        switch (this.cpntTipo) {
          case 'dev_fornecedor':
            queryGet.field_virtual = [ 'credito_fornecedor_historico' ]
            break

          case 'dev_cliente':
            queryGet.field_virtual = [ 'credito_cliente_historico' ]
            break
        }

        // SETA O WHERE QUE DEVE REALIZAR
        queryGet.where = { f: 'id', o: '=', v: this.cpntIdCon }

        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI('/contato/get', 'POST', queryGet, (retorno) => {
          // FORMATA OS NUMEROS RECEBIDOS
          for (var index1 in retorno.data[0].virtual_credito_cliente_historico) {
            if (index1 !== 'Historico') {
              retorno.data[0].virtual_credito_cliente_historico['_' + index1] = this.$store.state.FUN_MASK_VALOR('valorMoeda', retorno.data[0].virtual_credito_cliente_historico[index1])
            } else {
              for (var index2 in retorno.data[0].virtual_credito_cliente_historico.Historico) {
                retorno.data[0].virtual_credito_cliente_historico.Historico[index2].valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', retorno.data[0].virtual_credito_cliente_historico.Historico[index2].valor)
                retorno.data[0].virtual_credito_cliente_historico.Historico[index2].saldo = this.$store.state.FUN_MASK_VALOR('valorMoeda', retorno.data[0].virtual_credito_cliente_historico.Historico[index2].saldo)
              }
            }
          }
          for (var index3 in retorno.data[0].virtual_credito_fornecedor_historico) {
            if (index3 !== 'Historico') {
              retorno.data[0].virtual_credito_fornecedor_historico['_' + index3] = this.$store.state.FUN_MASK_VALOR('valorMoeda', retorno.data[0].virtual_credito_fornecedor_historico[index3])
            } else {
              for (var index4 in retorno.data[0].virtual_credito_fornecedor_historico.Historico) {
                retorno.data[0].virtual_credito_fornecedor_historico.Historico[index4].valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', retorno.data[0].virtual_credito_fornecedor_historico.Historico[index4].valor)
                retorno.data[0].virtual_credito_fornecedor_historico.Historico[index4].saldo = this.$store.state.FUN_MASK_VALOR('valorMoeda', retorno.data[0].virtual_credito_fornecedor_historico.Historico[index4].saldo)
              }
            }
          }

          // SETA OS DADOS DO CONTATO RECEBIDO
          this.contatoCre = retorno.data[0]

          // EXECUTA O CALLBACK
          if (callback !== null) {
            callback()
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }, this.conCreDevSetarStatusGeral)
      },
      conCreDevOnClickRecibo: function (tipo) {
        switch (tipo) {
          case 'cliente':
            this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'abrir_doc_id', params: { cts: this.$store.state.token.cts, nome: 'dev_cliente', id: this.cpntIdCon, tipo: 'rec-cre-cliente', formato: 'html' } }).href, 'iframe-hidden', {}, false)
            break

          case 'fornecedor':
            this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'abrir_doc_id', params: { cts: this.$store.state.token.cts, nome: 'dev_fornecedor', id: this.cpntIdCon, tipo: 'rec-cre-fornecedor', formato: 'html' } }).href, 'iframe-hidden', {}, false)
            break
        }
      },
      conCreDevAlterarTipo: function () {
        this.conCreDevBuscarValores(() => {
          if (Object.keys(this.contatoCre).length >= 1) {
            if (this.cpntTipo === 'dev_cliente') {
              this.contatoCre.extrato = this.contatoCre.virtual_credito_cliente_historico.Historico
            } else if (this.cpntTipo === 'dev_fornecedor') {
              this.contatoCre.extrato = this.contatoCre.virtual_credito_fornecedor_historico.Historico
            }
          }
        })
      },
      conCreDevAbrirDemanda: function (demanda, codigo) {
        // SETA O NOME DA ROTA QUE DEVE ABRIR
        var params = { name: '', params: { cts: this.$store.state.token.cts, id: codigo } }

        // VERIFICA O TIPO DE PAGINA QUE DEVE ABRIR
        switch (demanda) {
          case 'venda':
          case 'dem_venda':
            params.name = 'venda_numero'
            break
        
          case 'compra':
          case 'dem_compra':
            params.name = 'compra_numero'
            break

          case 'dev_cliente':
          case 'dem_dev_cliente':
            params.name = 'dev_cliente_nova_numero'
            break

          case 'dev_fornecedor':
          case 'dem_dev_fornecedor':
            params.name = 'dev_fornecedor_nova_numero'
            break
        }

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve(params).href, '_blank')
      }
    },
    watch: {
      cpntTipo: function () {
        this.conCreDevAlterarTipo()
      }
    }
  }
</script>
